import { ListCard } from '@capsicum/common-web';
import styled from 'styled-components';

export const Card = styled(ListCard)`
	padding: ${({ theme }) => theme.spacings.small};
	height: 100%;
	box-sizing: border-box;
	min-height: ${({ theme }) => `calc(${theme.sizing.xlargeTop} + ${theme.spacings.small} * 2)`};
`;

export const CardStart = styled(ListCard.Start)`
	${({ theme }) => theme.border.radius.circle};
	padding: 0;
`;

export const CardContent = styled(ListCard.Content)`
	gap: ${({ theme }) => theme.spacings.xxxsmall};
	padding: ${({ theme }) => `${theme.spacings.xxxsmall} ${theme.spacings.xxsmall}`};
`;

export const CardRow = styled(ListCard.Row)`
	justify-content: flex-start;
	gap: ${({ theme }) => theme.spacings.xxxsmall};
`;

export const Subtitle = styled(ListCard.Text)`
	${({ theme }) => theme.fonts.text.caption2};
	color: ${({ theme }) => theme.colors.text.main.subtle};
`;

export const AssetAmount = styled(Subtitle)`
	${({ theme }) => theme.fonts.text.caption1};
`;

export const CardEnd = styled(ListCard.End)`
	padding: 0;
`;
